var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"hide-scroll"},[_c('v-main',[_c('HitBanner',{attrs:{"end-date":_vm.endDate,"dialog":_vm.dialog,"img-src":_vm.popupImgSrc,"persistent":_vm.persistent,"isSales":_vm.isSales,"link-url":_vm.linkUrl},on:{"close":_vm.closePopup}}),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }